export const VehicleColors = [
  {
    label: 'Negro',
    value: 'Negro',
  },
  {
    label: 'Gris',
    value: 'Gris'
  },
  {
    label: 'Blanco',
    value: 'Blanco',
  },
  {
    label: 'Rojo',
    value: 'Rojo',
  },
  {
    label: 'Azul',
    value: 'Azul',
  },
  {
    label: 'Verde',
    value: 'Verde',
  },
  {
    label: 'Amarillo',
    value: 'Amarillo',
  },
];
